import { actions } from './laboratory_cabinet/actions'
import { getters } from './laboratory_cabinet/getters'
import { state } from './laboratory_cabinet/state'
import { mutations } from './laboratory_cabinet/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
